<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Low Stock
        <small>Items at or below reorder level</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">IMS / Reports</a> /
        <span class="current">Low Stock</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-exclamation-triangle" style="color:#ef4444;"></i>
        <h2>Low Stock</h2>
        <span class="report-badge danger">{{ items().length }} items</span>
      </div>
    </div>
    <div class="report-body">
      <div class="low-stock-list">
        @for (item of items(); track item.id) {
          <div class="low-stock-item">
            <span class="item-name">{{ item.name }}</span>
            <span class="item-stock" [class.low]="stockLevelClass(item) === 'low'" [class.out]="stockLevelClass(item) === 'critical'">
              {{ item.stockLevel }} / {{ item.reorderLevel }}
            </span>
          </div>
        } @empty {
          <p class="report-empty">No low stock items found.</p>
        }
      </div>
      <div class="report-footer">
        <span>Showing {{ items().length }} low stock items for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
